export default __webpack_public_path__ + "static/media/videogame.c62937a2.png";